import { config } from 'config';

interface GetUrlsResult {
  BASE_URL: string;
  BILLING_URL: string;
}

export function getUrls(href = window.location.href): GetUrlsResult {
  const isProxy = href.includes('ru.alivewater.cloud');
  const isKzProxy = href.includes('kz.alivewater.cloud');

  if (isKzProxy) {
    return {
      BASE_URL: config.KZ_PROXY,
      BILLING_URL: config.KZ_PROXY
    };
  }

  const BASE_URL = isProxy ? config.PROXY : config.CABINET_API;

  return {
    BASE_URL,
    BILLING_URL: BASE_URL
  };
}
